import React, { Fragment } from 'react';

import ModalHeaderV2 from './modal-header-v2';
import CartQuantityIndicator from './cart-quantity-indicator';
import withWindowResize from '../../ui/components/window-resize';
import Button from '../../ui/components/button';
import CartButton from '../../shared/components/cart-button';

import '../css/xsell-modal-printer.less';
import '../css/two-up-v2.less';

class TwoUpV2 extends React.PureComponent {

	handleContinueClick = () => {
		const { proceed, version, ctaMetrics } = this.props;
		proceed(version, ctaMetrics);
	}

	render() {
		const { xSellProductList, productInfo, closeModal, device } = this.props;
		return (
			<Fragment>
				<CartQuantityIndicator device={device} />
				<ModalHeaderV2 productInfo={productInfo} />
				<div className='modal-content'>
					<h3 className='subtitle'>{device !== 'mobile' ? 'For your convenience, we are adding our most popular back-up cartridges to your printer order' : 'Add catridges to your product'}</h3>
					<div className='products-section'>
						<div className='xsell-product-list'>
							{ xSellProductList }
						</div>
					</div>
				</div>
				<div className='modal-footer'>
					<div className='btn-container'>
						 <CartButton
						 	animatedBtnProps={{type: 'tertiary', action: 'remove'}}
							buttonText={device === 'mobile' ? 'No thanks' : 'No thanks, please remove'}
							className='two-up-modal-v2' 
							useAnimatedBtn={true} 
							className='continue-shopping'
						/>
						<Button 
							text='Go to cart' 
							className='two-up-modal-v2' 
							onClick={this.handleContinueClick}
						/>
					</div>
				</div>
			</Fragment>
		)
	}
}

export default withWindowResize(TwoUpV2);